export enum LayerGroupName {
  EXTRA = 'EXTRA',
  ANALYTIC = 'ANALYTIC',
  BACKGROUND_INSIDE = 'BACKGROUND_INSIDE',
  FIELD_INFO = 'FIELD_INFO',
  BASEMAP = 'BASEMAP',
  VEGETATIVE_INDEX = 'VEGETATIVE_INDEX'
}
